import { Suspense } from 'react';
import { lazily } from 'react-lazily';

import { AppLayout } from '.';
import { AppContent } from '../../app/app-content';
import { useHomepageRedesignEnabled } from '../../modules/bonus-feed/features/recognition/components/BonusFeed/hooks/useHomepageRedesignEnabled';
import { App as TopNavbar } from '../../modules/top-navbar/components/App';
import { MobileActionBar } from '../action-bar/mobile-action-bar';
import { Reveal } from '../display/reveal';

const { GlobalModals } = lazily(() => import('../../app/global-modals'));

export const AppRootLayout = () => {
	const isHomepageRedesignEnabled = useHomepageRedesignEnabled();

	return (
		<AppLayout navbar={<TopNavbar />}>
			<Suspense>
				<GlobalModals />
			</Suspense>

			<AppContent />

			{/* Old MobileActionBar - only shown when homepage redesign is disabled */}
			<Reveal if={!isHomepageRedesignEnabled}>
				<MobileActionBar />
			</Reveal>
		</AppLayout>
	);
};
